import React, { FC } from 'react';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { styled } from 'linaria/react';
import { useIntersectionObserver } from '@shared/lib';
import FullViewportHeightSection from './FullViewportHeightSection';
import SectionBg from './SectionBg';
import Title from './Title';
import Description from './Description';
import TakeParticipationButton from './TakeParticipationButton';
import participationRulesBgDesktop from '../../assets/new-year/participation-rules-bg-desktop.jpg';
import participationRulesBgTablet from '../../assets/new-year/participation-rules-bg-tablet.jpg';
import participationRulesBgMobile from '../../assets/new-year/participation-rules-bg-mobile.jpg';
import iphoneImg from '../../assets/new-year/iphone.png';
import mistletoeImg from '../../assets/new-year/mistletoe.png';
import candyCaneImg from '../../assets/new-year/candy-cane.png';
import giftBoxImg from '../../assets/new-year/gift-box.png';
import globeImg from '../../assets/new-year/globe.png';
const DynamicScrollDownAnimation = dynamic(() => import('./ScrollDownAnimation').then(imported => imported.default), {
  loading: () => <div />,
  ssr: false
});
const ParticipationRulesSectionView: FC = () => {
  const [sectionRef, isSectionVisible] = useIntersectionObserver<HTMLDivElement>({
    threshold: 0.85,
    triggerOnce: true
  });
  return <FullViewportHeightSection>
      <SectionBg desktopImg={participationRulesBgDesktop} tabletImg={participationRulesBgTablet} mobileImg={participationRulesBgMobile}>
        <ParticipationRulesSectionViewWrapper ref={sectionRef}>
          <OpacityAnimation isSectionVisible={isSectionVisible}>
            <TextWrapper>
              <Title>Kак принять участие?</Title>
              <Description>
                Нажмите «Принять участие» и&nbsp;введите ваш&nbsp;номер телефона.
                <br />
                Важно, чтобы&nbsp;телефон для&nbsp;участия в&nbsp;акции совпадал с&nbsp;телефоном, с&nbsp;которого
                будете пополнять игровой аккаунт
              </Description>
            </TextWrapper>
            <TakeParticipationButtonWrapper>
              <TakeParticipationButton withSnow variant="green" />
            </TakeParticipationButtonWrapper>
          </OpacityAnimation>
          <IPhoneImageWrapper isSectionVisible={isSectionVisible}>
            <Image src={iphoneImg} alt="IPhone" width={527} height={426} />
          </IPhoneImageWrapper>
          <MistletoeWrapper isSectionVisible={isSectionVisible}>
            <Image src={mistletoeImg} alt="Омела" width={358} height={348} />
          </MistletoeWrapper>
          <CandyCaneWrapper isSectionVisible={isSectionVisible}>
            <Image src={candyCaneImg} alt="Леденец" width={384} height={487} />
          </CandyCaneWrapper>
          <GiftBoxWrapper isSectionVisible={isSectionVisible}>
            <Image src={giftBoxImg} alt="Подарок" width={431} height={431} />
          </GiftBoxWrapper>
          <GlobeWrapper isSectionVisible={isSectionVisible}>
            <Image src={globeImg} alt="Шар" width={423} height={423} />
          </GlobeWrapper>
          <ScrollDownWrapper>
            <DynamicScrollDownAnimation isTextBlack />
          </ScrollDownWrapper>
        </ParticipationRulesSectionViewWrapper>
      </SectionBg>
    </FullViewportHeightSection>;
};
export default ParticipationRulesSectionView;
const ParticipationRulesSectionViewWrapper = /*#__PURE__*/styled('div')({
  name: "ParticipationRulesSectionViewWrapper",
  class: "puzvg4e",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? 'none' : 'translateY(60px)';
const _exp2 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? '1' : '0';
const OpacityAnimation = /*#__PURE__*/styled('div')({
  name: "OpacityAnimation",
  class: "o162krnd",
  propsAsIs: false,
  vars: {
    "o162krnd-0": [_exp()],
    "o162krnd-1": [_exp2()]
  }
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1eslav5",
  propsAsIs: false
});
const TakeParticipationButtonWrapper = /*#__PURE__*/styled('div')({
  name: "TakeParticipationButtonWrapper",
  class: "t1jj1asr",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? 'translate(0, 0)' : 'translate(0, 60px)';
const _exp4 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? '1' : '0';
const IPhoneImageWrapper = /*#__PURE__*/styled('div')({
  name: "IPhoneImageWrapper",
  class: "ifcycv9",
  propsAsIs: false,
  vars: {
    "ifcycv9-0": [_exp3()],
    "ifcycv9-1": [_exp4()]
  }
});
const _exp5 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? 'translate(-50%, -15%)' : 'translate(-99%, 0%)';
const MistletoeWrapper = /*#__PURE__*/styled('div')({
  name: "MistletoeWrapper",
  class: "mshwnaq",
  propsAsIs: false,
  vars: {
    "mshwnaq-0": [_exp5()]
  }
});
const _exp6 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? 'translateX(50%)' : 'translate(99%, 50%)';
const CandyCaneWrapper = /*#__PURE__*/styled('div')({
  name: "CandyCaneWrapper",
  class: "c1sjghh2",
  propsAsIs: false,
  vars: {
    "c1sjghh2-0": [_exp6()]
  }
});
const _exp7 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? 'translate(30%, -30%)' : 'translate(99%, -50%)';
const GiftBoxWrapper = /*#__PURE__*/styled('div')({
  name: "GiftBoxWrapper",
  class: "g181meib",
  propsAsIs: false,
  vars: {
    "g181meib-0": [_exp7()]
  }
});
const _exp8 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? 'translate(30%, -50%)' : 'translate(99%, 50%)';
const GlobeWrapper = /*#__PURE__*/styled('div')({
  name: "GlobeWrapper",
  class: "g481pc3",
  propsAsIs: false,
  vars: {
    "g481pc3-0": [_exp8()]
  }
});
const ScrollDownWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollDownWrapper",
  class: "s5f5754",
  propsAsIs: false
});

require("./ParticipationRulesSectionView.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ParticipationRulesSectionView.tsx");